module.exports = __webpack_public_path__ + "static/media/Workout1.e3cb91a9.png";